const initialState = {
    users: [],
    loading: false,
    error: null,
    syncLoading: false,
    syncSuccess: false,
    syncError: null,
};

export const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_ALL_USERS_REQUEST':
            return { ...state, loading: true, error: null };
        case 'FETCH_ALL_USERS_SUCCESS':
            return { ...state, loading: false, users: action.payload };
        case 'FETCH_ALL_USERS_FAILURE':
            return { ...state, loading: false, error: action.payload };

        case 'SYNC_USER_ROLES_REQUEST':
            return { ...state, syncLoading: true, syncSuccess: false, syncError: null };
        case 'SYNC_USER_ROLES_SUCCESS':
            return { ...state, syncLoading: false, syncSuccess: true };
        case 'SYNC_USER_ROLES_FAILURE':
            return { ...state, syncLoading: false, syncError: action.payload };

        default:
            return state;
    }
};
